<template functional>
  <div class="card-content">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "CardContent"
};
</script>
